// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"482":"f992a7073bbf1a07860f","655":"d33a22ff0904b42af038"}[chunkId] + ".js");